'use client'

import { FallbackProps } from 'react-error-boundary'
import { Button } from '@/shared/ui/button'

export function ErrorFallback({ resetErrorBoundary }: FallbackProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-destructive">Что-то пошло не так</h1>
        <p className="mt-2 text-muted-foreground">Произошла непредвиденная ошибка</p>
      </div>

      <div className="flex gap-2">
        <Button onClick={resetErrorBoundary}>Попробовать снова</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Перезагрузить страницу
        </Button>
      </div>
    </div>
  )
}
